var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXlsx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 34.643V5.357C8 4.608 8.624 4 9.393 4h12.179L32 14.16v20.483c0 .749-.624 1.357-1.393 1.357H9.393C8.624 36 8 35.392 8 34.643z",
    fill: "#659C35"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m21.574 4 10.428 10.16h-9.035c-.769 0-1.393-.608-1.393-1.357V4z",
    fill: "#DFE9E2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.383 31.734h.969l1.414-2.152h.03l1.407 2.152h1.024l-1.875-2.804v-.016l1.91-2.816h-.985L12.88 28.28h-.04l-1.394-2.183h-1.043l1.856 2.789v.011l-1.875 2.836zm5.941 0h3.516v-.754H17.2v-4.882h-.876v5.636zm6.531.137c1.313 0 2.153-.672 2.153-1.75v-.004c0-.836-.485-1.312-1.668-1.566l-.613-.137c-.73-.156-1.028-.43-1.028-.848v-.003c0-.532.488-.84 1.149-.84.683-.004 1.125.332 1.199.793l.008.05h.847l-.004-.054c-.062-.875-.843-1.551-2.039-1.551-1.195 0-2.039.672-2.043 1.645v.003c0 .832.493 1.364 1.637 1.606l.617.133c.746.16 1.051.441 1.051.875v.004c0 .523-.512.882-1.23.882-.754 0-1.297-.328-1.344-.84l-.004-.042h-.86l.005.05c.078.95.894 1.594 2.168 1.594zm2.872-.137h.968l1.414-2.152h.032l1.406 2.152h1.023l-1.875-2.804v-.016l1.91-2.816h-.984l-1.398 2.183h-.04l-1.394-2.183h-1.043l1.856 2.789v.011l-1.875 2.836z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXlsx);
export default __webpack_public_path__ + "static/media/xlsx.6ee70b768a90c549a87133ea54208a01.svg";
export { ForwardRef as ReactComponent };